<template>
  <div>
    <!-- 我要竞价 -->
    <div class="jBtn" v-if="type==0">
      <div class="jBtn1" @click.stop="attention(item,false,'/sv1/tender/userFocus/editBid')">
        <template v-if="item.userFocusFlag == 0">
          <img src="@/assets/noguanzhupic.png" alt />
          <span>关注</span>
        </template>
        <template v-else>
          <img src="@/assets/guanzhupic.png" alt />
          <span>已关注</span>
        </template>
      </div>
      <div class="jBtn3" @click="inByLetDialogClick(item.id,0,item)">函询</div>
      <div class="jBtn4" @click="toChat(item.customerServiceContactsId)">交流</div>
      <div class="jBtn2" @click.stop="goBidPage(item)">我要竞价</div>

    </div>
    <div class="itemHover itemHoverTwo" v-else-if="type == 1 && (item.state == 8 || item.dataSources === 2)">
      <div @click.stop="attention(item,false,'/sv1/tender/userFocus/editTender')">
        <div v-if="item.userFocusFlag == 0" class="guanzhu">
          <img src="@/assets/noguanzhupic.png" width="18" height="16" />
          <span>关注</span>
        </div>
        <div v-else class="guanzhu">
          <img src="@/assets/guanzhupic.png" width="18" height="16" />
          <span>已关注</span>
        </div>
      </div>
    </div>
    <div class="itemHover" v-else-if="type == 1 && item.state !== 8">
      <div @click.stop="go(item.id)" v-if="item.state == 9">我要报名</div>
      <div @click="go(item.id)" v-else-if="item.state == 2">我要投标</div>
      <div v-else style="background-color: #F5F7FA;color: #C0C4CC;cursor:not-allowed">我要投标</div>
      <div @click.stop="attention(item,false,'/sv1/tender/userFocus/editTender')">
        <div v-if="item.userFocusFlag == 0" class="guanzhu">
          <img src="@/assets/noguanzhupic.png" width="18" height="16" />
          <span>关注</span>
        </div>
        <div v-else class="guanzhu">
          <img src="@/assets/guanzhupic.png" width="18" height="16" />
          <span>已关注</span>
        </div>
      </div>
      <div class="guanzhu" @click="inByLetDialogClick(item.id,1,item)">
        <img src="@/assets/hanxun.png" width="19" height="14" />
        <span>函询</span>
      </div>
      <div class="guanzhu" @click="toChat(item.customerServiceContactsId)">
        <img src="@/assets/kefu.png" width="19" height="19" />
        <span>交流</span>
      </div>
    </div>

    <!-- 招标预告 -->
    <div class="jBtn5" v-else-if="type == 2 || item.state == 8">
      <div class="advance-jpop">
        <template>
          <!-- jBtn4 -->
            <div
              class="guanzhu"
               v-if="item.userFocusFlag == 0"
              @click.stop="
                attention(item, false, 'sv1/tender/userFocus/editTender')
              "
            >
              <img src="@/assets/noguanzhupic.png" alt />
              <span>关注</span>
          </div>
          <div
            v-else
            class="guanzhu"
            @click.stop="
                attention(item, false, 'sv1/tender/userFocus/editTender')
            "
          >
            <img src="@/assets/guanzhupic.png" alt />
              <span>已关注</span>
          </div>
          <div class="" @click.stop="inByLetDialogClick(item.id, type, item)">
            函询
          </div>
          <div class="" @click.stop="toChat(item.customerServiceContactsId)">
            交流
          </div>

        </template>
      </div>
    </div>
    <!-- <div class="jBtn5" v-else-if="type==2 || item.state == 8 || item.dataSources === 2">
      <div class="jBtn6" @click.stop="attention(item,false,'/sv1/tender/userFocus/editTender')">
        <template v-if="item.userFocusFlag == 0">
          <img src="@/assets/noguanzhupic.png" alt />
          <span>关注</span>
        </template>
        <template v-else>
          <img src="@/assets/guanzhupic.png" alt />
          <span>已关注</span>
        </template>
      </div>
    </div> -->
     <!-- 企业专项 -->
    <div class="company" v-else-if="type==3">
      <div class="focus" v-if="!item.focus" @click="clickAttention(true, item.companyNo,item)">
          <img src="@/assets/noguanzhupic.png" alt />
          <span>关注</span>
      </div>
      <div class="focus" v-else @click="clickAttention(false,item.companyNo,item)">
          <img src="@/assets/guanzhupic.png" alt />
          <span>已关注</span>
      </div>
      <div class="hanxun" @click="inByLetDialogClick(item.id,2,item)">函询</div>
      <div class="shenqing" @click="userApplyFun">申请加盟</div>
      <div class="yaoqing" @click="InvitedJoinFun">邀请加盟</div>
    </div>
    <!-- 需求预告 -->
    <div class="demand" v-else-if="type==5 || type==6">
      <div class="guanzhu" v-if="item.userFocusFlag == 0" @click.stop="attention(item,false,'/sv1/tender/userFocus/editTender')">
        <img src="@/assets/noguanzhupic.png" alt />
        <span>关注</span>
      </div>
      <div class="guanzhu" @click.stop="attention(item,false,'/sv1/tender/userFocus/editTender')" v-else>
        <img src="@/assets/guanzhupic.png" alt />
        <span>已关注</span>
      </div>
      <div class="jiaoliu" @click.stop="toDeamndChat()">
        <img src="@/assets/kefu.png" alt />
        <span>交流</span>
      </div>
      <div class="baojia" @click.stop="demandoffer(item,dialog)" v-if="item.type == 2">我要报名</div>
      <div class="baojia" @click.stop="demandoffer(item,dialog)" v-else>我要报价</div>
    </div>
    <!-- <div class="demand" v-else-if="type==5">
      <div class="baojia" @click.stop="demandoffer(item,dialog)">我要报价</div>
    </div>
    <div class="demand" v-else-if="type==6">
      <div class="baojia" @click.stop="demandoffer(item,dialog)">我要报价</div>
    </div> -->

    <!-- 招标||报名 -->
    <div class="jBtn" v-else>
      <div class="jBtn1" @click.stop="attention(item,false,'/sv1/tender/userFocus/editTender')">
        <template v-if="item.userFocusFlag == 0">
          <img src="@/assets/noguanzhupic.png" alt />
          <span>关注</span>
        </template>
        <template v-else>
          <img src="@/assets/guanzhupic.png" alt />
          <span>已关注</span>
        </template>
      </div>
      <div class="jBtn3" @click="inByLetDialogClick(item.id,1,item)">函询</div>
      <div class="jBtn4" @click="toChat(item.customerServiceContactsId)">交流</div>
      <div class="jBtn2" @click.stop="go(item.id)" v-if="item.state == 9">我要报名</div>
      <div class="jBtn2" @click="go(item.id)" v-else-if="item.state == 2 || item.state == 6">我要投标</div>
      <div
        v-else
        style="background-color: #F5F7FA;color: #C0C4CC;cursor:not-allowed"
        class="jBtn2"
      >我要投标</div>
    </div>

  </div>
</template>

<script>
import axios from '@/http/zhaocai'
import { apiHome } from '@/api/zhaocai/apiHome'
import eventBus from '@/utils/event-bus'

import { mapGetters } from 'vuex'

export default {
  name: '',
  mixins: [],
  extends: {},
  components: {},
  props: {
    item: {
      type: Object
    },
    type: {
      type: Number
    },
    listIndex: {
      type: Number
    },
    dialog: {
      type: Boolean
    },
    jIndex: {
      type: Number
    }
  },
  data () {
    return {
      isRepeatSubmit: false,
      dialogShow: 1
    }
  },
  filters: {},
  watch: {
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  methods: {
    // 函询
    inByLetDialogClick (e, s, obj) {
      this.$emit('inByLetDialogClick', e, s, obj)
    },
    // 跳转
    go (e) {
      this.$emit('go', e)
    },
    // 竞价 跳转
    goBidPage (obj) {
      window.open( process.env.VUE_APP_ZHAOCAI+'/CompeteBiddingDetail?no=' + obj.id + '&typeName=' + obj.typeName)
    },
    //我要报价——企业需求
    demandoffer(item) {
      if(this.permissionTips()) return
        if (this.type == 5) {
          if (item.businessType != 3) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/demandNoticeDetail" + "?id=" + item.id);
          } else {
            if (item.type && item.type == 3) {
              window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?id=" + item.id);
            } else if (item.type && item.type == 2) {
              window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.id + "&&type=10");
            } else if (item.type && item.type == 19) {
              window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.id + "&&type=9");
            } else if (item.type && item.type == 20) {
              window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.id + "&&type=8");
            } else if (item.type) {
              window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.id);
            }
          }
        } else {
          if (item.type && item.type == 8) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.no + "&&type=8");
          } else if(item.type && item.type == 10){
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.no + "&&type=10");
          } else if (item.type) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.no);
          } else if (item.logisticsDemandName) {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?no=" + item.no + "&&type=9");
          } else {
            window.open(process.env.VUE_APP_ZHAOCAI+"/companyDemandDetail" + "?id=" + item.id);
          }
        }
    },
    //交流
    toDeamndChat() {
      if (!this.$store.state.loginType) {
        this.$store.commit("SET_LOGINDIALOG", true);
      } else {
        eventBus.$emit("sendImMessage", this.item.customerImAccount);
      }
    },
    offer (item, dialog) {
      // 判断是否是团队和组织如果是团队和组织就不允许报价
      if (this.getUser.type == 2 || this.getUser.type == 3) {
        this.$message({
          type: 'error',
          message: '暂不支持团队、组织身份参与，请切换身份为企业或个人后参与'
        })
        return
      }
      if (this.listIndex != 0 && this.listIndex != 5) {
        this.$emit('dialogShowNum', this.dialogShow, item)
      }
      if (dialog == true) {
        window.open(`${process.env.VUE_APP_ZHAOCAI}/demandEsDetail?id=${item.id}&type=${item.type}`)
      }
    },
    // 关注
    attention (item, state, url) {
      if(this.permissionTips()) return

      if (this.isRepeatSubmit) return
      this.isRepeatSubmit = true
      // 关注
      let data = {}
      if (this.type == 0) {
        data.bidNo = item.id
      } else {
        data.tenderNo = item.id
      }

      axios
        .post(url, data)
        .then(res => {
          this.isAttention = state
          if (res.data.code == 0) {
            item.userFocusFlag = !item.userFocusFlag
            this.$message.success(res.data.msg)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .finally(() => {
          this.isRepeatSubmit = false
        })
    },
    // 交流
    toChat (e) {
      if(this.permissionTips()) return

      if (!e) {
        this.$message.error('招标方未设置客服人员，不支持交流！')
      } else {
        axios
          .get(process.env.VUE_APP_COMPANY + '/v1/organization/getUser/' + e)
          .then(res => {
            if (res.data.code == 200) {
              // this.$store.commit("SET_ISOPEN", true);
              // this.$store.commit("SETTOUSER", res.data.data.imAccount);
              // im消息
              if (!res.data.data.imAccount) {
                this.$message.error('当前客服不存在')
                return false
              }
              eventBus.$emit('sendImMessage', res.data.data.imAccount)

              //       let obj = {
              //          name: this.item.name,
              //          imAccount:  this.item.customerServiceImAccount,
              //          serStaff:  this.item.customerServiceName,
              //          id:  this.item.id,
              //          type: 'TENDER',
              //          userIstrue:this.item.customerServiceImAccount === this.$store.state.user.imAccount
              //       }
              //       eventBus.$emit('sendImMessage', obj)
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => console.log(err))
      }
    },
    // 点击关注
    clickAttention (state, no, item) {
      if (!this.$store.state.loginType) {
        this.$store.commit('SET_LOGINDIALOG', true)
      } else {
        let params = {
          // businessNo: this.companyNo,
          businessNo: no,
          type: 0
        }
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        apiHome
          .attentionHandle(params)
          .then(res => {
            if (res.data && res.data.code === 200) {
              // this.isAttention = state;
              item.focus = state
              if (state) {
                this.$message.success('关注成功')
              } else {
                this.$message.success('取消关注成功')
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })
      }
    },
    userApplyFun () {
      this.$emit('userApply')
    },
    InvitedJoinFun () {
      this.$emit('InvitedJoin')
    }
  },
  created () {},
  mounted () {}
}
</script>

<style lang="scss" scoped>
.itemHover {
  width: 426px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  display: flex;
  .guanzhu img {
    margin-right: 10px;
  }
  div {
    width: 105px;
    height: 137px;
    background-color: #409ee9;
    color: #ffffff;
    border-right: 2px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
  }
  div:last-child {
    border: none;
  }
}
.itemHoverTwo{
   div {
    width: 427px;
   }
}
.jBtn {
  width: 100%;
  position: relative;
  left: -1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e4e7ed;
  border-top: none;
  .jBtn1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 40px;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    background: #b79255;
    margin-right: 1px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
  .jBtn2 {
    width: 30%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
    background: #b79255;
    margin-right: 1px;
    // background-color: #409ee9;
  }
  .jBtn3 {
    width: 20%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    background: #b79255;
    margin-right: 1px;
  }
  .jBtn4 {
    width: 20%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    background: #b79255;
    margin-right: 1px;
  }
}
.jBtn5 {
  width: 100%;
  position: relative;
  left: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid red#e4e7ed;
  border-top: none;
  background: #b79255;
  color: #ffffff;
  .jBtn6 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 40px;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
}
.demand{
  width: 100%;
  position: absolute;
  bottom: -40px;
  left: -1px;
  display: flex;
  justify-content: space-around;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #b79255;
  border-top: none;
  background: #b79255;
  color: #ffffff;
  .guanzhu,
  .jiaoliu {
    display: flex;
    width: 33.3%;
    height: 40px;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    border-right: 1px solid #fff;
    img {
      width: 16px;
      height: 16px;
      margin-right: 7px;
    }
  }
  .baojia {
    width: 33.3%;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
.companys {
  top: -10px;
}
.company , .companys{
  width: 100%;
  position: relative;
  left: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;
  // border: 1px solid red#e4e7ed;
  border: 1px solid #b79255;
  border-top: none;
  background: #b79255;
  color: #ffffff;

  .focus{
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    line-height: 40px;
    margin-right: 1px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
  .hanxun{
    width: 25%;
    text-align: center;
    margin-right: 1px;
    height: 40px;
    line-height: 40px;
    border-left: 1px solid #ffffff;

  }
  .shenqing{
    width: 25%;
    text-align: center;
    margin-right: 1px;
    height: 40px;
    line-height: 40px;
    border-left: 1px solid #ffffff;
  }

  .yaoqing{
    width: 25%;
    text-align: center;
    margin-right: 1px;
    height: 40px;
    line-height: 40px;
    border-left: 1px solid #ffffff;
  }
}
</style>
